import { useContext } from 'react';
import { HcaptchaContext, type HcaptchaContextValue } from '../context/HcaptchaContext';

/**
 * Hook to access hCaptcha configuration.
 * Must be used within HcaptchaProvider.
 */
export function useHcaptcha(): HcaptchaContextValue {
  const context = useContext(HcaptchaContext);

  if (!context) {
    throw new Error('useHcaptcha must be used within an HcaptchaProvider');
  }

  return context;
}
